import { useEffect, useState } from "react";
import useCountTimer from "../useCountTimer";

const useInfiniteMapEvents = (array: any[]) => {
  const [arrIndexes, setArrIndexes] = useState({
    start: 0,
    end: 10,
  });

  const [displayedArray, setDisplayedArray] = useState(
    array.slice(arrIndexes.start, arrIndexes.end)
  );

  const { count } = useCountTimer();

  useEffect(() => {
    if (array.length > 0) {
      setDisplayedArray(array.slice(arrIndexes.start, arrIndexes.end));
    }
  }, [array]);

  useEffect(() => {
    const start = arrIndexes.start;
    const end = arrIndexes.end;

    if (arrIndexes.end >= array.length) {
      setArrIndexes({
        start: 0,
        end: 10,
      });
    } else {
      setArrIndexes({
        start: end,
        end: end + 10,
      });
    }

    const next10 = array.slice(arrIndexes.start, arrIndexes.end);
    setDisplayedArray(next10);
  }, [count]);

  return {
    displayedArray,
  };
};

export default useInfiniteMapEvents;
